/**
 * I3 — Marquee Whisper (Immersive Garden 톤)
 *
 * 거대 마키 텍스트가 hero 하단에서 느리게 흐름 (15s/loop, linear).
 * 마우스 hover 시 살짝 가속/감속 가능 (옵션).
 *
 * 트리거: <div data-anim="marquee-whisper" data-marquee-speed="15">
 *           <div class="marquee-whisper__track">
 *             <span>RESEARCH · MATTER · SYSTEMS · INSTITUTE · </span>
 *             <span>RESEARCH · MATTER · SYSTEMS · INSTITUTE · </span>
 *           </div>
 *         </div>
 *   • CSS animation 으로 무한 루프 (track 1세트 = 전체 폭, 두 세트 = 200%)
 *   • prefers-reduced-motion 시 정적 표시 (animation: none)
 *
 * 가이드: plan §2.1 / §7.1 A-2b
 *
 * 주: 기존 jquery.marquee (lib/marquee) 와 별개. 이 컨트롤러는 CSS animation 기반.
 */

import { motionOK } from "./MotionTokens";

export class MarqueeWhisperController {
    static init(): void {
        const tracks = Array.from(
            document.querySelectorAll<HTMLElement>('[data-anim="marquee-whisper"]'),
        );
        if (!tracks.length) return;

        const reduced = !motionOK();

        tracks.forEach((wrap) => {
            const track = wrap.querySelector<HTMLElement>(".marquee-whisper__track");
            if (!track) return;

            const speed = Number(wrap.dataset.marqueeSpeed || "15"); // seconds per loop
            if (reduced) {
                track.style.animation = "none";
                return;
            }
            track.style.animationName = "ui-marquee-whisper";
            track.style.animationDuration = `${speed}s`;
            track.style.animationTimingFunction = "linear";
            track.style.animationIterationCount = "infinite";
            track.style.willChange = "transform";

            // hover 시 일시정지 (Lusion/Unseen 톤). 단 data-marquee-pause-on-hover="false"
            // 인 마키(예: home.theh-solution)는 끊김 없이 계속 흐르도록 리스너를 붙이지 않는다.
            const pauseOnHover = wrap.dataset.marqueePauseOnHover !== "false";
            if (pauseOnHover) {
                wrap.addEventListener("mouseenter", () => {
                    track.style.animationPlayState = "paused";
                });
                wrap.addEventListener("mouseleave", () => {
                    track.style.animationPlayState = "running";
                });
            }
        });
    }
}
